/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ResearchProposalAcceptDTO
 */
export interface ResearchProposalAcceptDTO {
	/**
	 *
	 * @type {string}
	 * @memberof ResearchProposalAcceptDTO
	 */
	researchProposalEnrollmentId?: string;
}

export function ResearchProposalAcceptDTOFromJSON(
	json: any
): ResearchProposalAcceptDTO {
	return ResearchProposalAcceptDTOFromJSONTyped(json, false);
}

export function ResearchProposalAcceptDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ResearchProposalAcceptDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		researchProposalEnrollmentId: !exists(json, "researchProposalEnrollmentId")
			? undefined
			: json["researchProposalEnrollmentId"],
	};
}

export function ResearchProposalAcceptDTOToJSON(
	value?: ResearchProposalAcceptDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		researchProposalEnrollmentId: value.researchProposalEnrollmentId,
	};
}
